// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__3sS4X","radioRow":"SimpleQuestionBuilderModal_radioRow__3cwcQ"};